import { AttributesMixin, define, Model, type } from "@type-r/models";
import { FilterType, GetFilteredImportTemplatesRequest } from "../import-templates/models/get-filtered-import-templates-request";
import { CompanyItem } from "./company";
import { getAuthorizationBearer, getPlatformCode } from "./endpoint";

export interface ImportTemplateStatus extends AttributesMixin<typeof ImportTemplateStatus> { }

@define
export class ImportTemplateStatus extends Model {
  static attributes = {
    isActive: Boolean
  }
}

export interface ImportTemplateCard extends AttributesMixin<typeof ImportTemplateCard> { }
@define
export class ImportTemplateCard extends Model {
  static attributes = {
    id: String,
    name: String,
    isDefault: Boolean,
    isActive: Boolean,
    isStandard: Boolean,
    isUserDefined: Boolean,
    assetTypeId: Number,
    createdBy: String,
    createdOn: Date,
    updatedOn: type(Date).null,
    companies: [CompanyItem]
  };

  async delete(): Promise<void> {
    const url = `api/v1/ingest/import-templates/${this.id}`;
    const payload = {
      id: this.id
    };
    const response = await fetch(url, {
      method: 'DELETE',
      headers: new Headers({
        "Authorization": getAuthorizationBearer(),
        'Content-Type': 'application/json',
        'X-Platform-Code': getPlatformCode()
      }),
      body: JSON.stringify(payload)
    });
    if (response.status < 200 || response.status >= 300) {
      let error = response.statusText || `HTTP Error ${response.status}`;
      await response.json()
        .then(e => error = e.error);
      throw new Error(error);
    }
    return await response.json();
  }

  async switchStatus(): Promise<ImportTemplateStatus> {
    const url = `api/v1/ingest/import-templates/${this.id}/switch`;

    const payload = {
      id: this.id,
      isActive: !this.isActive
    };

    const response = await fetch(url, {
      method: 'PUT',
      headers: new Headers({
        "Authorization": getAuthorizationBearer(),
        'Content-Type': 'application/json',
        'X-Platform-Code': getPlatformCode()
      }),
      body: JSON.stringify(payload)
    });

    if (response.status < 200 || response.status >= 300) {
      let error = response.statusText || `HTTP Error ${response.status}`;
      await response.json()
        .then(e => error = e.error)
        .catch(e => console.error('Cannot parse response data'));
      throw new Error(error);
    }

    const json = await response.json();
    this.set({
      isActive: json.isActive
    });
    return this;
  }
}

export interface ImportTemplates extends AttributesMixin<typeof ImportTemplates> { }
@define
export class ImportTemplates extends Model {
  static attributes = {
    items: [ImportTemplateCard]
  }
}

export async function getFiltered(request?: GetFilteredImportTemplatesRequest): Promise<ImportTemplates> {
  let url: string = 'api/v1/ingest/import-templates';

  if (request) {
    const searchParams = new URLSearchParams();
    if (request.companyIds && +request.filterType === FilterType.company) {
      request.companyIds.map((item: any) => {
        searchParams.append("companyIds", `${item.id}`);
      });
    }
    if (request.assetTypeId && +request.filterType === FilterType.assetType) {
      searchParams.append("assetTypeId", `${request.assetTypeId}`);
    }
    if (request.quickSearch && +request.filterType === FilterType.all) {
      searchParams.append("quickSearch", `${request.quickSearch}`);
    }
    searchParams.append("filterType", `${request.filterType}`);
    searchParams.append("sortBy", `${request.sortBy}`);
    searchParams.append("asc", `${request.asc}`);

    var seracsearchParamsURl = searchParams.toString()
    if (seracsearchParamsURl) {
      url += `?${seracsearchParamsURl}`
    }
  }

  return (await fetch(url, {
    method: 'GET',
    headers: new Headers({
      "Authorization": getAuthorizationBearer(),
      'X-Platform-Code': getPlatformCode()
    }),
  })).json();
}
